<template>
    <div ref="top">
        <div class="mb-5">
            <h3>Thank You For Your Order!</h3>
            <p>The ACG Credit Card Services Team will review the request and provide approval within 3 business. Pending item availability, orders will be fulfilled and shipped out within 10 business days of order approval.</p>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    mounted() {
        const el = this.$refs.top;

        if (el) {
            el.scrollIntoView({behavior: 'smooth'});
        }
    }
}
</script>
